module.exports = __webpack_public_path__ + "img/check.a3ef626f.svg";